module.exports = __webpack_public_path__ + "img/survey.63ca139a.png";